'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Button, Input } from 'dumb';
import { TableList, TableListCell, TableListRow } from 'dumb/tables/table-list';
import { ModalRow } from 'dumb/modal';

// phrases/ constants/utils
import phrases from './../../../posTiers.phrases';

class PosTiersBatchStepList extends Component {
	_onRemoveEntry(identifier) {
		const { removeBatchListItem } = this.props;

		removeBatchListItem(identifier);
	}

	_editListEntry(e, row, type) {
		const value = e?.target?.value ?? e;

		// edits the row in the store
		this.props.editBatchListItem({
			identifier: row.identifier,
			[type]: value,
		});
	}

	render() {
		const { batchList, addBatchListItemRow } = this.props;

		return (
			<>
				<TableList>
					<thead>
						<tr>
							<th>{phrases.MODAL_BATCH_STEP_LIST_TABLE_NUMBER}</th>
							<th>{phrases.MODAL_BATCH_STEP_NAME}</th>
							<th>{phrases.MODAL_BATCH_STEP_DESCRIPTION}</th>
							<th>{phrases.MODAL_BATCH_STEP_SORT_ORDER}</th>
							<th>{phrases.MODAL_BATCH_STEP_EXTERNAL_ID}</th>

							<th />
						</tr>
					</thead>
					<tbody>
						{batchList.map((entry, i) => {
							const deleteRowButtonDisabled = batchList.length === 1;

							return (
								<TableListRow key={entry.identifier}>
									<TableListCell>{i + 1}</TableListCell>

									<TableListCell>
										<Input
											id="name"
											placeholder={phrases.MODAL_BATCH_STEP_NAME_PLACEHOLDER}
											onChange={(e) =>
												this._editListEntry(e, entry, 'name')
											}
											required
											value={entry.name}
										/>
									</TableListCell>

									<TableListCell>
										<Input
											id="description"
											placeholder={
												phrases.MODAL_BATCH_STEP_DESCRIPTION_PLACEHOLDER
											}
											value={entry.description}
											onChange={(event) =>
												this._editListEntry(event, entry, 'description')
											}
										/>
									</TableListCell>
									<TableListCell>
										<Input
											id="sortOrder"
											type="number"
											placeholder={
												phrases.MODAL_BATCH_STEP_SORT_ORDER_PLACEHOLDER
											}
											value={entry.sortOrder}
											onChange={(event) =>
												this._editListEntry(event, entry, 'sortOrder')
											}
										/>
									</TableListCell>

									<TableListCell>
										<Input
											id="externalId"
											type="number"
											placeholder={
												phrases.MODAL_BATCH_STEP_EXTERNAL_ID_PLACEHOLDER
											}
											value={entry.externalId}
											onChange={(event) =>
												this._editListEntry(event, entry, 'externalId')
											}
										/>
									</TableListCell>

									<TableListCell>
										<Button
											type="negative"
											size="tiny"
											disabled={deleteRowButtonDisabled}
											onClick={() => this._onRemoveEntry(entry.identifier)}>
											<span className="icon icon--delete" />
										</Button>
									</TableListCell>
								</TableListRow>
							);
						})}
					</tbody>
				</TableList>

				<ModalRow
					typeAddNewRow
					tooltipText={phrases.MODAL_BATCH_STEP_LIST_ADD_NEW_ROW_TOOLTIP}
					tooltipZIndex={600}
					onClick={addBatchListItemRow}
				/>
			</>
		);
	}
}

PosTiersBatchStepList.propTypes = {
	batchList: PropTypes.array,
	editBatchListItem: PropTypes.func,
	removeBatchListItem: PropTypes.func,
	addBatchListItemRow: PropTypes.func,
};

export default PosTiersBatchStepList;
